import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isPriceManualSource',
  standalone: true,
})
export class IsPriceManualSourcePipe implements PipeTransform {
  transform(sources: any[], ...args: unknown[]): unknown {
    if (!sources) {
      return false;
    }
    return sources?.find((source) => source?.type === 'price' && source?.source === 'manual') !== undefined;
  }
}
